import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)
// // 解决编程式路由往同一地址跳转时会报错的情况
// const originalPush = Router.prototype.push;
// const originalReplace = Router.prototype.replace;

// // push
// Router.prototype.push = function push(location, onResolve, onReject) {
//   if (onResolve || onReject)
//     return originalPush.call(this, location, onResolve, onReject);
//   return originalPush.call(this, location).catch(err => err);
// };

// //replace
// Router.prototype.replace = function push(location, onResolve, onReject) {
//   if (onResolve || onReject)
//     return originalReplace.call(this, location, onResolve, onReject);
//   return originalReplace.call(this, location).catch(err => err);
// };
export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/Public/Introduce'
    },
    {
      path: '/Public',
      name: 'Public',
      component: () => import('@/components/Public'),
      children:[
        {
          path: 'Signin',
          name: 'Signin',
          component: () => import('@/components/Signin'), // 登录
        },
        {
          path: 'Signinhide',
          name: 'Signinhide',
          component: () => import('@/components/Signinhide'), // 登录2
        },
        {
          path: 'Introduce',
          name: 'Introduce',
          component: () => import('@/components/Introduce'), // 介绍
        },
        {
          path: 'Notice',
          name: 'Notice',
          component: () => import('@/components/Notice'), // 公告
        },
        {
          path: 'Signup',
          name: 'Signup',
          component: () => import('@/components/Signup'), // 报名提交
        },
        {
          path: 'Group',
          name: 'Group',
          component: () => import('@/components/Group'), // 群二维码展示
        },
        {
          path: 'NoticeDetails',
          name: 'NoticeDetails',
          component: () => import('@/components/NoticeDetails'), // 公告详情
        },
        {
          path: 'pdfcs',
          name: 'pdfcs',
          component: () => import('@/components/pdfcs'), // 公告详情
        },
        {
          path: 'upload',
          name: 'upload',
          component: () => import('@/components/upload'), // 上传作品
          meta:{
            requireAuth: true
          }
        },
        {
          path: 'Judges',
          name: 'Judges',
          component: () => import('@/components/Judges'), // 专家评委
        },
        {
          path: 'popularity',
          name: 'popularity',
          component: () => import('@/components/popularity'), // 作品人气投票
        },
        {
          path: 'WorkDetails',
          name: 'WorkDetails',
          component: () => import('@/components/WorkDetails'), // 作品详情
        },
        {
          path: 'Award',
          name: 'Award',
          component: () => import('@/components/Award'), // 获奖名单展示
        },
        {
          path: 'major',
          name: 'major',
          component: () => import('@/components/major'), // 获奖名单展示
        },
        {
          path: 'otherCompetitions',
          name: 'otherCompetitions',
          component: () => import('@/components/otherCompetitions'), // 其他精彩赛事
        }

        
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js